import React from 'react';
import { FDStack, FDBodyText } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import useMobileLayout from 'Hooks/useMobileLayout';

export const InfluencerDescription = () => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();

  if (!isMobile) { return null; }
  if (!resource.attr('pageDescription')) { return null; }

  let description = resource.attr('pageDescription');

  if (resource.isTruthy('influencerSubtitleIsSplit')) {
    description = `*${resource.attr('pageDescription')}`;
  }


  return (
    <FDStack direction={'column'} spacing={2} flex={1} maxWidth={720} width={'100%'}>

      <Richtext
        Component={FDBodyText}
        value={description}
        richtext={resource.metaField('pageDescription').attr('hint') === 'richtext'}
      />
    </FDStack>
  );
};
